import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['step1', 'step2']

  nextStep() {
    const form = this.element
    if (!$(form).valid()) return;

    this.step1Target.classList.add('d-none')
    this.step2Target.classList.remove('d-none')
  }

  previousStep() {
    this.step2Target.classList.add('d-none')
    this.step1Target.classList.remove('d-none')
  }

  validateMembers(event) {
    const selectedUsers = this.element.querySelectorAll(
      'input[name="room[user_ids][]"]'
    )

    const error = this.element.querySelector(".target_user_error")

    if (selectedUsers.length === 0) {
      event.preventDefault()
      error.classList.remove("d-none")
      return false
    }

    error.classList.add("d-none")
    return true
  }
}
